import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlarmBellRing = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.5 7.5a1 1 0 0 0 0.87 -0.5 5.43 5.43 0 0 1 2.09 -2.1 1 1 0 1 0 -1 -1.74 7.25 7.25 0 0 0 -1.6 1.22A7.59 7.59 0 0 0 3.63 6 1 1 0 0 0 4 7.37a1 1 0 0 0 0.5 0.13Z",
			fill: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.43 0.71A1 1 0 0 0 5.19 0 7.52 7.52 0 0 0 0 5.19a1 1 0 0 0 0.71 1.24A1 1 0 0 0 2 5.77a5.69 5.69 0 0 1 1.4 -2.41A5.71 5.71 0 0 1 5.76 2 1 1 0 0 0 6.43 0.71Z",
			fill: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.15 4.39a7.27 7.27 0 0 0 -1.63 -1.23 1 1 0 1 0 -1 1.74A5.43 5.43 0 0 1 18.63 7a1 1 0 0 0 1.74 -1 7.56 7.56 0 0 0 -1.22 -1.61Z",
			fill: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24 5.19A7.52 7.52 0 0 0 18.81 0a1 1 0 0 0 -0.57 2 5.71 5.71 0 0 1 2.4 1.4A5.69 5.69 0 0 1 22 5.77a1 1 0 0 0 1.25 0.66A1 1 0 0 0 24 5.19Z",
			fill: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5 21.5h-3a0.5 0.5 0 0 0 -0.5 0.5 2 2 0 0 0 4 0 0.5 0.5 0 0 0 -0.5 -0.5Z",
			fill: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 18.5a1 1 0 0 1 -1 -1V13c0 -3.45 -2.17 -6.32 -5 -6.87V4.5a1 1 0 0 0 -2 0v1.63C8.17 6.68 6 9.55 6 13v4.5a1 1 0 0 1 -1 1 1 1 0 0 0 0 2h14a1 1 0 0 0 0 -2Z",
			fill: "currentColor",
			strokeWidth: 1
		})
	] })
});
export { SvgAlarmBellRing as ReactComponent };
